import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  mercadoPago: null
};

const slice = createSlice({
  name: 'metodosPagos',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    setMercadoPago(state, action) {
      state.mercadoPago = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const { startLoading, setMercadoPago } = slice.actions;
